import { rgba } from 'polished';
import { neutralColors } from './colors/colors.js';

var DROP_SHADOWS = ["0px 8px 8px ".concat(rgba(neutralColors.smoke, 0.08)), "0px 8px 16px ".concat(rgba(neutralColors.smoke, 0.24)), "0px 16px 24px ".concat(rgba(neutralColors.smoke, 0.32)), "0px 24px 32px ".concat(rgba(neutralColors.smoke, 0.32))];
function getDropShadowByElevation(level) {
  return level ? DROP_SHADOWS[level - 1] : void 0;
}

export { getDropShadowByElevation };
